import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.cPwv2c',
    defaultMessage: 'Privacy policy',
  },
  description: {
    id: 'studio.iGnSuL',
    defaultMessage: 'Why and how we use your data',
  },
});
